module.exports = __webpack_public_path__ + "img/projects-4.7d73a3b1.jpg";